import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import type { Control, FieldValues, Path } from 'react-hook-form';

export interface AutocompleteOption {
  label: string;
  value: string;
}

interface FormAutocompleteProps<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  options: AutocompleteOption[];
  selectorAttribute?: Record<string, string>;
}

export const ControlledAutocomplete = <TFieldValues extends FieldValues>({
  name,
  control,
  options,
  selectorAttribute,
}: FormAutocompleteProps<TFieldValues>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Autocomplete
          fullWidth
          autoHighlight
          size="small"
          disableClearable
          options={options}
          renderInput={(params) => (
            <TextField
              {...params}
              slotProps={{
                ...params.slotProps,

                htmlInput: {
                  ...params.slotProps.htmlInput,
                  autoComplete: 'new-password',
                }
              }}
            />
          )}
          getOptionLabel={(option) => option.label}
          onChange={(_, newValue) => {
            field.onChange(newValue?.value);
          }}
          value={options.find((option) => option.value === field.value)}
          {...selectorAttribute}
        />
      )}
    />
  );
};
